// extracted by mini-css-extract-plugin
export default {"container":"index_container_Iz1xs","containerLogo":"index_containerLogo_FUqSH"};